import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ArrowRight, Shield, Clock, Zap, Users, Bot, GitMerge, BarChart2, MessageSquare, FileText, Building, Database, Star } from 'lucide-react';
export const Vision = () => {
  return <div className="bg-black text-white min-h-screen font-sans" data-id="element-806">
      <Navbar data-id="element-807" />
      <main data-id="element-808">
        {/* Hero Section */}
        <section className="relative overflow-hidden bg-gradient-to-b from-black via-zinc-950 to-zinc-900 py-24 lg:py-32" data-id="element-809">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(255,255,255,0.05)_0,_transparent_70%)]" data-id="element-810"></div>
          <div className="absolute inset-0 bg-[linear-gradient(to_right,_rgba(255,255,255,0.01)_1px,_transparent_1px),_linear-gradient(to_bottom,_rgba(255,255,255,0.01)_1px,_transparent_1px)] bg-[size:40px_40px]" data-id="element-811"></div>
          {/* Decorative elements */}
          <div className="absolute top-20 left-10 w-64 h-64 bg-white/5 rounded-full filter blur-3xl" data-id="element-812"></div>
          <div className="absolute bottom-10 right-10 w-80 h-80 bg-zinc-800/20 rounded-full filter blur-3xl" data-id="element-813"></div>
          <div className="container mx-auto px-4 relative z-10" data-id="element-814">
            <div className="max-w-4xl mx-auto text-center" data-id="element-815">
              <div className="inline-block px-4 py-1 bg-white/5 backdrop-blur-sm rounded-full border border-white/10 mb-6" data-id="element-816">
                <span className="font-['Playfair_Display'] text-zinc-400 text-sm tracking-wider" data-id="element-817">
                  THE FUTURE OF LEGAL ASSISTANCE
                </span>
              </div>
              <h1 className="font-['Playfair_Display'] text-5xl md:text-7xl font-light mb-8 leading-tight" data-id="element-818">
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-white via-white to-zinc-400" data-id="element-819">
                  Our Vision
                </span>
              </h1>
              <p className="font-['Space_Grotesk'] text-zinc-300 text-lg md:text-xl mb-10 max-w-2xl mx-auto" data-id="element-820">
                Transforming how the legal industry conducts business by
                augmenting human capabilities with AI assistance.
              </p>
            </div>
          </div>
        </section>
        {/* Main Content */}
        <section className="relative py-20" data-id="element-821">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(255,255,255,0.02)_0,_transparent_50%)]" data-id="element-822"></div>
          <div className="container mx-auto px-4 relative z-10" data-id="element-823">
            <div className="max-w-4xl mx-auto" data-id="element-824">
              {/* Our Mission Section */}
              <div className="mb-32 relative" data-id="element-825">
                <div className="absolute -left-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-826"></div>
                <div className="flex items-center mb-10" data-id="element-827">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-828">
                    <Shield size={24} className="text-white" data-id="element-829" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-830">
                    Our <span className="text-white" data-id="element-831">Mission</span>
                  </h2>
                </div>
                <div className="ml-16 bg-gradient-to-br from-zinc-900/80 to-black/80 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-832">
                  <p className="font-['Space_Grotesk'] text-zinc-200 text-lg mb-6 leading-relaxed" data-id="element-833">
                    Veterans in legal call centers and AI-powered communications
                    technology have combined forces to offer a hybrid human+AI
                    platform that handles all intake communications for law
                    firms.
                  </p>
                  <p className="font-['Space_Grotesk'] text-zinc-200 text-lg leading-relaxed" data-id="element-834">
                    Our team of AI and legal technology experts has developed an
                    intelligent system that enhances your existing intake
                    process, allowing your firm to respond to every inquiry
                    instantly without adding staff.
                  </p>
                </div>
              </div>
              {/* The Evolution Section */}
              <div className="mb-32 relative" data-id="element-835">
                <div className="absolute -right-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-836"></div>
                <div className="flex items-center mb-10" data-id="element-837">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-838">
                    <GitMerge size={24} className="text-white" data-id="element-839" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-840">
                    The <span className="text-white" data-id="element-841">Evolution</span>
                  </h2>
                </div>
                <div className="ml-16" data-id="element-842">
                  <p className="font-['Space_Grotesk'] text-zinc-300 text-lg mb-8 leading-relaxed" data-id="element-843">
                    We start with intake but are also working on AI solutions
                    that can enhance every aspect of your client communication
                    that doesn't require a law license.
                  </p>
                  <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-844">
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-6 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-845">
                      <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-4" data-id="element-846">
                        <MessageSquare size={24} className="text-white" data-id="element-847" />
                      </div>
                      <h3 className="font-['Playfair_Display'] text-xl mb-3" data-id="element-848">
                        Communication Handling
                      </h3>
                      <p className="text-zinc-400 font-['Playfair_Display'] text-sm" data-id="element-849">
                        Handle routine communications and followups with clients
                      </p>
                    </div>
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-6 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-850">
                      <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-4" data-id="element-851">
                        <FileText size={24} className="text-white" data-id="element-852" />
                      </div>
                      <h3 className="font-['Playfair_Display'] text-xl mb-3" data-id="element-853">
                        Claims Processing
                      </h3>
                      <p className="text-zinc-400 font-['Playfair_Display'] text-sm" data-id="element-854">
                        Assist with claims verification and coordination with
                        providers
                      </p>
                    </div>
                  </div>
                  <div className="relative mb-8" data-id="element-855">
                    <div className="absolute -inset-1 bg-gradient-to-r from-white/10 via-white/5 to-transparent rounded-sm blur" data-id="element-856"></div>
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-8 rounded-sm border border-white/10 backdrop-blur-sm relative" data-id="element-857">
                      <h3 className="font-['Playfair_Display'] text-2xl mb-6" data-id="element-858">
                        Replacing Traditional Roles
                      </h3>
                      <p className="text-zinc-300 font-['Playfair_Display']" data-id="element-859">
                        Our vision extends to augmenting traditional paralegal
                        and case manager roles, creating a more efficient
                        workflow where:
                      </p>
                      <div className="mt-8 grid md:grid-cols-2 gap-6" data-id="element-860">
                        <div className="flex flex-col items-center text-center p-6 bg-black/40 rounded-sm" data-id="element-861">
                          <Users size={28} className="text-white mb-4" data-id="element-862" />
                          <h4 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-863">
                            Human Staff
                          </h4>
                          <p className="text-zinc-400 text-sm font-['Playfair_Display']" data-id="element-864">
                            Focus on complex tasks requiring human judgment
                          </p>
                        </div>
                        <div className="flex flex-col items-center text-center p-6 bg-black/40 rounded-sm" data-id="element-865">
                          <Bot size={28} className="text-white mb-4" data-id="element-866" />
                          <h4 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-867">
                            AI Case Manager
                          </h4>
                          <p className="text-zinc-400 text-sm font-['Playfair_Display']" data-id="element-868">
                            Handles routine tasks with efficiency and precision
                          </p>
                        </div>
                      </div>
                      <p className="text-zinc-300 font-['Playfair_Display'] mt-8" data-id="element-869">
                        Clients interact with a consistent AI assistant that
                        works alongside your team, creating a seamless
                        experience.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Built by Proven Experts Section */}
              <div className="mb-32 relative" data-id="element-870">
                <div className="absolute -left-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-871"></div>
                <div className="flex items-center mb-6" data-id="element-872">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-873">
                    <Star size={24} className="text-white" data-id="element-874" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-875">
                    Built by <span className="text-white" data-id="element-876">Proven Experts</span>
                  </h2>
                </div>
                <div className="ml-16" data-id="element-877">
                  <p className="font-['Space_Grotesk'] text-zinc-300 text-lg mb-8 leading-relaxed" data-id="element-878">
                    LexSquire was co-founded by veteran leaders in:
                  </p>
                  <div className="grid md:grid-cols-2 gap-6" data-id="element-879">
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-6 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-880">
                      <div className="flex items-center mb-4" data-id="element-881">
                        <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center mr-3" data-id="element-882">
                          <Users size={20} className="text-white" data-id="element-883" />
                        </div>
                        <h3 className="font-['Playfair_Display'] text-xl" data-id="element-884">
                          Human Expertise
                        </h3>
                      </div>
                      <p className="font-['Space_Grotesk'] text-zinc-400 ml-13 pl-2" data-id="element-885">
                        Human call centers specializing in legal intake
                      </p>
                    </div>
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-6 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-886">
                      <div className="flex items-center mb-4" data-id="element-887">
                        <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center mr-3" data-id="element-888">
                          <Bot size={20} className="text-white" data-id="element-889" />
                        </div>
                        <h3 className="font-['Playfair_Display'] text-xl" data-id="element-890">
                          AI Innovation
                        </h3>
                      </div>
                      <p className="font-['Space_Grotesk'] text-zinc-400 ml-13 pl-2" data-id="element-891">
                        AI-powered communications technology development
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Integration Section */}
              <div className="mb-32 relative" data-id="element-892">
                <div className="absolute -left-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-893"></div>
                <div className="flex items-center mb-10" data-id="element-894">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-895">
                    <Database size={24} className="text-white" data-id="element-896" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-897">
                    Seamless <span className="text-white" data-id="element-898">Integration</span>
                  </h2>
                </div>
                <div className="ml-16" data-id="element-899">
                  <div className="bg-gradient-to-br from-zinc-900/50 to-black/50 p-8 rounded-sm border border-white/10 backdrop-blur-sm mb-8" data-id="element-900">
                    <div className="grid md:grid-cols-2 gap-8" data-id="element-901">
                      <div data-id="element-902">
                        <h3 className="font-['Playfair_Display'] text-2xl mb-6" data-id="element-903">
                          Practice Management
                        </h3>
                        <p className="font-['Space_Grotesk'] text-zinc-300 mb-6" data-id="element-904">
                          Our system integrates with all major practice
                          management software, ensuring seamless data flow and
                          eliminating duplicate data entry.
                        </p>
                        <div className="flex items-center justify-center p-4 bg-zinc-900/70 rounded-sm" data-id="element-905">
                          <Building size={32} className="text-white mr-4" data-id="element-906" />
                          <span className="text-zinc-300 font-['Playfair_Display']" data-id="element-907">
                            Complete ecosystem compatibility
                          </span>
                        </div>
                      </div>
                      <div data-id="element-908">
                        <h3 className="font-['Playfair_Display'] text-2xl mb-6" data-id="element-909">
                          AI Tools
                        </h3>
                        <p className="font-['Space_Grotesk'] text-zinc-300 mb-6" data-id="element-910">
                          We integrate with new and incoming wave of legal AI
                          tools, creating a comprehensive solution for modern
                          law firms.
                        </p>
                        <div className="flex items-center justify-center p-4 bg-zinc-900/70 rounded-sm" data-id="element-911">
                          <Bot size={32} className="text-white mr-4" data-id="element-912" />
                          <span className="text-zinc-300 font-['Playfair_Display']" data-id="element-913">
                            Future-proof technology
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-zinc-900/50 to-black/50 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-914">
                    <h3 className="font-['Playfair_Display'] text-2xl mb-6" data-id="element-915">
                      Data Access & Intelligence
                    </h3>
                    <p className="font-['Space_Grotesk'] text-zinc-300 mb-8" data-id="element-916">
                      Our AI can have access to all systems data, enabling
                      intelligent decision-making and proactive case management
                      without compromising security or confidentiality.
                    </p>
                    <div className="grid md:grid-cols-3 gap-6" data-id="element-917">
                      <div className="bg-zinc-900/70 p-5 rounded-sm text-center" data-id="element-918">
                        <Clock size={24} className="text-white mx-auto mb-3" data-id="element-919" />
                        <p className="text-zinc-300 text-sm font-['Playfair_Display']" data-id="element-920">
                          Real-time access
                        </p>
                      </div>
                      <div className="bg-zinc-900/70 p-5 rounded-sm text-center" data-id="element-921">
                        <Shield size={24} className="text-white mx-auto mb-3" data-id="element-922" />
                        <p className="text-zinc-300 text-sm font-['Playfair_Display']" data-id="element-923">
                          Secure processing
                        </p>
                      </div>
                      <div className="bg-zinc-900/70 p-5 rounded-sm text-center" data-id="element-924">
                        <BarChart2 size={24} className="text-white mx-auto mb-3" data-id="element-925" />
                        <p className="text-zinc-300 text-sm font-['Playfair_Display']" data-id="element-926">
                          Intelligent insights
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Knight and Squire Section */}
              <div className="mb-20 relative" data-id="element-927">
                <div className="absolute -right-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-928"></div>
                <div className="relative" data-id="element-929">
                  <div className="absolute -inset-1 bg-gradient-to-r from-white/20 via-white/10 to-transparent rounded-sm blur" data-id="element-930"></div>
                  <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-10 rounded-sm border border-white/10 backdrop-blur-sm relative" data-id="element-931">
                    <div className="flex flex-col md:flex-row items-center" data-id="element-932">
                      <div className="md:w-1/2 mb-8 md:mb-0 md:pr-8" data-id="element-933">
                        <img src="https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Knight armor representing the legal profession" className="rounded-sm shadow-lg border border-white/10" data-id="element-934" />
                      </div>
                      <div className="md:w-1/2" data-id="element-935">
                        <h2 className="font-['Playfair_Display'] text-3xl mb-6 font-light leading-tight" data-id="element-936">
                          "Like knights once relied on squires to prepare them
                          for battle..."
                        </h2>
                        <p className="font-['Space_Grotesk'] text-zinc-200 text-lg leading-relaxed mb-8" data-id="element-937">
                          Tomorrow's lawyers will rely on LexSquire to handle
                          the operational burdens of intake, leaving them free
                          to focus on the fight for their clients.
                        </p>
                        <a href="https://calendly.com/lexsquire-info/30min" className="bg-white text-black px-8 py-4 rounded-sm hover:bg-zinc-200 transition-colors inline-flex items-center" data-id="element-938">
                          Join Our Vision
                          <ArrowRight size={18} className="ml-2" data-id="element-939" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Final CTA Section */}
              <div className="relative mb-20" data-id="element-940">
                <div className="absolute inset-0 bg-gradient-to-r from-zinc-900/50 via-zinc-800/50 to-zinc-900/50 rounded-sm blur" data-id="element-941"></div>
                <div className="relative bg-gradient-to-br from-zinc-900 to-zinc-800 p-10 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-942">
                  <div className="text-center" data-id="element-943">
                    <h3 className="font-['Playfair_Display'] text-2xl mb-6 font-light" data-id="element-944">
                      Ready to be part of the future of legal practice?
                    </h3>
                    <p className="font-['Space_Grotesk'] text-white text-lg max-w-2xl mx-auto mb-8" data-id="element-945">
                      Join us in revolutionizing how law firms operate and
                      provide services to their clients.
                    </p>
                    <a href="https://bots.messagesimproved.com/sign-up-auth/?brand=lexsquire" className="bg-white text-black px-8 py-4 rounded-sm hover:bg-zinc-200 transition-colors inline-flex items-center" data-id="element-946">
                      Get Started Today
                      <ArrowRight size={18} className="ml-2" data-id="element-947" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-948" />
    </div>;
};